export default "__VITE_ASSET__auPloNbi__"